import { useContestantStore, useEventCommonStore } from '@/stores';
import { computed, onMounted } from 'vue';

export const useRelay = () => {
    /**
     * We need the contestant store to check for relay contestants
     */
    const contestantStore = useContestantStore();

    /**
     * We need the event common to check for races
     */
    const eventCommonStore = useEventCommonStore();

    /**
     * Check if this is a relay event or not
     * @return {boolean} Whether this is a relay event
     */
    const isRelayEvent = computed(() => {
        const hasRelayContestants = contestantStore.Contestants.some((c) => (c.RelayTeamName ?? '') !== '');
        const hasRelayRaces = eventCommonStore.Races.some(
            (r) => (r.RelayTeamMaxContestants ?? 0) > 0 || (r.RelayTeamMinContestants ?? 0) > 0,
        );
        return hasRelayContestants || hasRelayRaces;
    });

    onMounted(async () => {
        await contestantStore.EnsureLoaded(['Contestants', 'RelayContestants']);
        await eventCommonStore.EnsureLoaded(['Races']);
    });

    return {
        /**
         * Check if this is a relay event or not
         * @return {boolean} Whether this is a relay event
         */
        IsRelayEvent: isRelayEvent,
    };
};
